<div class="statuser">
  @if (antallDokumenterTilSignering() > 0) {
    <div class="status-kontainer">
      <div (click)="aapneEllerLukkDokumenterTilSignering()" class="status" data-testid="signeringer">
        <mat-icon fontSet="lederplan-ikon-signer" class="entitet-ikon mat-icon--lederplan-ikon"/>
        <div class="tittel">{{ 'Dokumenter til signering'|translate }}</div>
        <div class="teller" data-testid="antall">({{ antallDokumenterTilSignering() }})</div>
        @if (viserDokumenterTilSignering()) {
          <mat-icon>keyboard_arrow_up</mat-icon>
        } @else {
          <mat-icon>keyboard_arrow_down</mat-icon>
        }
      </div>
      <div class="aktiv-indikator-kontainer">
        @if (viserDokumenterTilSignering()) {
          <div class="aktiv-indikator" @fadeInnUt></div>
        }
      </div>
    </div>
  }

  @if (antallOppgaver() > 0) {
    <div class="status-kontainer">
      <div (click)="aapneEllerLukkOppgaver()" class="status" data-testid="oppgaver">
        <mat-icon fontSet="lederplan-ikon-oppgave" class="entitet-ikon mat-icon--lederplan-ikon"/>
        <div class="tittel">{{ 'Oppgaver'|translate }}</div>
        <div class="teller" data-testid="antall">({{ antallOppgaver() }})</div>
        @if (viserOppgaver()) {
          <mat-icon>keyboard_arrow_up</mat-icon>
        } @else {
          <mat-icon>keyboard_arrow_down</mat-icon>
        }
      </div>
      <div class="aktiv-indikator-kontainer">
        @if (viserOppgaver()) {
          <div class="aktiv-indikator" @fadeInnUt></div>
        }
      </div>
    </div>
  }

  @if (antallAvstemninger() > 0) {
    <div class="status-kontainer">
      <div (click)="aapneEllerLukkAvstemninger()" class="status" data-testid="avstemninger">
        <mat-icon fontSet="lederplan-ikon-oppgave" class="entitet-ikon mat-icon--lederplan-ikon"/>
        <div class="tittel">{{ 'Avstemninger'|translate }}</div>
        <div class="teller" data-testid="antall">({{ antallAvstemninger() }})</div>
        @if (viserAvstemninger()) {
          <mat-icon>keyboard_arrow_up</mat-icon>
        } @else {
          <mat-icon>keyboard_arrow_down</mat-icon>
        }
      </div>
      <div class="aktiv-indikator-kontainer">
        @if (viserAvstemninger()) {
          <div class="aktiv-indikator" @fadeInnUt></div>
        }
      </div>
    </div>
  }

  @if (antallUndersoekelser() > 0) {
    <div class="status-kontainer">
      <div (click)="aapneEllerLukkUndersoekelser()" class="status" data-testid="spørreundersøkelser">
        <mat-icon class="entitet-ikon">content_paste_search</mat-icon>
        <div class="tittel">{{ 'Spørreundersøkelser'|translate }}</div>
        <div class="teller" data-testid="antall">({{ antallUndersoekelser() }})</div>
        @if (viserUndersoekelser()) {
          <mat-icon>keyboard_arrow_up</mat-icon>
        } @else {
          <mat-icon>keyboard_arrow_down</mat-icon>
        }
      </div>
      <div class="aktiv-indikator-kontainer">
        @if (viserUndersoekelser()) {
          <div class="aktiv-indikator" @fadeInnUt></div>
        }
      </div>
    </div>
  }

  @if(antallDokumenterTilSignering() == 0 && antallOppgaver() == 0 && antallAvstemninger() == 0 &&  antallUndersoekelser() == 0){
    <div class="ingen-status" data-testid="ingenstatus">
      {{ 'Du har ingen oppgaver, dokumenter til signering, avstemninger eller spørreundersøkelser '|translate }}
      <mat-icon>celebration</mat-icon>
    </div>
  }
</div>

<div class="popup-kontainer" data-testid="dashboardstatus-popup">
  @if (viserDokumenterTilSignering()) {
    <dokumenter-til-signering-popup
            (vedLukk)="lukkDokumenterTilSignering()"
            [dokumenterBrukerIkkeHarSignert]="dokumenterBrukerIkkeHarSignert()"
            [dokumenterAndreSkalSignere]="dokumenterAndreSkalSignere()"
            [maksPopupHoeyde]="maksPopupHoeyde()"
            @fadeInnUt
    />
  }

  @if (viserOppgaver()) {
    <oppgaver-popup
            (vedLukk)="lukkOppgaver()"
            [brukersOppgaver]="brukersOppgaver()"
            [antallOppgaverPerBruker]="antallOppgaverPerBruker()"
            [maksPopupHoeyde]="maksPopupHoeyde()"
            @fadeInnUt
    />
  }

  @if (viserAvstemninger()) {
    <avstemninger-popup
            (vedLukk)="lukkAvstemninger()"
            [avstemningerBrukerIkkeHarStemtPaa]="avstemningerBrukerIkkeHarStemtPaa()"
            [avstemningerAndreIkkeHarStemtPaa]="avstemningerAndreIkkeHarStemtPaa()"
            [maksPopupHoeyde]="maksPopupHoeyde()"
            @fadeInnUt
    />
  }

  @if (viserUndersoekelser()) {
    <spoerreundersoekelser-popup
            (vedLukk)="lukkUndersoekelser($event)"
            [ubesvarteUndersoekelser]="ubesvarteUndersoekelser()"
            [maksPopupHoeyde]="maksPopupHoeyde()"
            @fadeInnUt
    />
  }

</div>
